<template>
  <div>
    <x-button
      id="current-location-button"
      appearance-color="secondary-white"
      :disabled="loading === true"
      data-tool-tip-target="current-location-button"
      @click="goToCurrentLocation"
    >
      <span class="accessible-name">Current Location</span>
      <x-loading-spinner v-if="loading === true" />
      <x-icon v-else icon="location" width="20" height="20" />
      <ys-text v-if="buttonText" type="body1-bold">
        {{ buttonText }}
      </ys-text>
    </x-button>

    <x-modal v-if="showDeniedModal" size="large" data-test="denied-modal">
      <div class="x-modal__contents">
        <x-heading size="3">Location Access Denied</x-heading>
        <x-body-text>
          In order to use this feature, we need access to your location. Please
          enable location permissions in your internet browser settings.
        </x-body-text>
      </div>
      <div class="x-modal__actions">
        <button @click="showDeniedModal = false">Ok</button>
      </div>
    </x-modal>
  </div>
</template>

<!-- eslint-disable vue/block-lang -->
<script>
/* eslint-disable vue/component-api-style */
import xButton from '@/components/shared/x-button'
import { goToCurrentLocation, geolocationEnabled } from '@/services/map-service'
import xModal from '@/components/shared/x-modal'
import xHeading from '@/components/shared/x-heading'
import XBodyText from '@/components/shared/x-body-text'
import xLoadingSpinner from '@/components/shared/x-loading-spinner'
import xIcon from '@/components/shared/x-icon'
import '@onxmaps/yellowstone-ui/ys-text'
import pubsub from '@/lib/pubsub'

export default {
  name: 'ControlUserLocation',

  components: {
    xButton,
    xModal,
    xHeading,
    XBodyText,
    xLoadingSpinner,
    xIcon,
  },

  props: {
    buttonText: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      showDeniedModal: false,
      loading: false,
    }
  },

  computed: {
    geolocationEnabled,
  },

  watch: {
    geolocationEnabled(val) {
      this.showDeniedModal = !val
    },
  },

  methods: {
    async goToCurrentLocation() {
      this.loading = true
      await goToCurrentLocation()
      this.showDeniedModal = !this.geolocationEnabled
      this.loading = false
      pubsub.publish('currentLocationClicked')
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@/styles/system/_shadow.scss';
@use '@/styles/system/_breakpoints.scss';

#current-location-button {
  &.x-button {
    height: 45px;
    width: 45px;
    margin-bottom: 0;
    padding: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: shadow.$Low;

    span {
      display: block;
      padding-top: 5px;
    }
  }
  :deep(.x-loading-spinner) {
    margin: 0px;
  }
  .accessible-name {
    font-size: 0;
  }
  ys-text {
    padding-left: var(--ys-spacing-50);
  }

  @include breakpoints.app-prototyping() {
    color: var(--ys-color-text-reverse);
    background-color: var(--ys-color-surface-reverse);

    :deep(.x-icon) {
      svg {
        fill: var(--ys-color-text-reverse);
      }
    }
  }
}

@media print {
  #current-location-button.x-button {
    display: none;
  }
}
</style>
